module.exports = __webpack_public_path__ + "img/teams.b028cdbd.svg";